<template>
    <div class="relative" :class="className">
        <label
            class="input-control input-control--radio | font-normal text-grey-800"
            :class="classLabel"
        >
            <div
                class="mr-2"
                :class="disabled ? 'cursor-not-allowed' : 'cursor-pointer'"
                v-if="$slots.before"
            >
                <slot name="before" />
            </div>
            <input
                type="radio"
                :name="name"
                :checked="state || undefined"
                :value="value"
                :disabled="disabled || undefined"
                @change="toggle"
            />
            <div class="input-control__indicator" />
            <div
                class="ml-2"
                :class="[disabled ? 'cursor-not-allowed' : 'cursor-pointer', classSlotWrapper]"
                v-if="$slots.default"
            >
                <slot />
            </div>
        </label>
    </div>
</template>

<script>
    /* eslint-disable vue/require-prop-types */

    export default {
        name: 'ActivixRadio',

        compatConfig: {
            MODE: 3,
            COMPONENT_V_MODEL: false,
        },

        emits: ['input', 'update:modelValue'],

        props: {
            name: {
                type: String,
                default: null,
            },
            value: {
                default: '',
            },
            disabled: {
                type: Boolean,
                default: false,
            },
            checked: {
                type: Boolean,
                default: false,
            },
            modelValue: {
                type: [String, Number, Boolean],
                default: undefined,
            },
            className: {
                type: String,
                default: 'inline-flex',
            },
            classLabel: {
                type: String,
                default: '',
            },
            classSlotWrapper: {
                type: String,
                default: '',
            },
        },

        computed: {
            state() {
                if (this.modelValue === undefined) {
                    return this.checked;
                }

                return this.modelValue === this.value;
            },
        },

        watch: {
            checked(newValue) {
                if (newValue !== this.state) {
                    this.toggle();
                }
            },
        },

        methods: {
            onChange() {
                this.toggle();
            },

            toggle() {
                const newValue = this.state ? '' : this.value;

                this.$emit('input', newValue);
                this.$emit('update:modelValue', newValue);
            },
        },

        mounted() {
            if (this.checked && !this.state) {
                this.toggle();
            }
        },
    };
</script>
